import AdminLayout from "@/components/admin/AdminLayout";
import RefundManager from "@/components/booking/RefundManager";

export default function AdminRefundsPage() {
  return (
    <AdminLayout testid="admin-refunds-shell">
      <RefundManager role="admin" testidPrefix="admin-refunds" />
    </AdminLayout>
  );
}
